import { render, staticRenderFns } from "./sysParams.vue?vue&type=template&id=f70280cc&scoped=true&"
import script from "./sysParams.vue?vue&type=script&lang=js&"
export * from "./sysParams.vue?vue&type=script&lang=js&"
import style0 from "./sysParams.vue?vue&type=style&index=0&id=f70280cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70280cc",
  null
  
)

export default component.exports